// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/OnlineUsersPage/OnlineUsersPage.module.css */
.OnlineUsersPage_onlineUsersPage__nJSZm {
  max-width: 400px;
  margin: 0 auto;
  padding: 16px;
  font-family: sans-serif;
}

.OnlineUsersPage_heading__iCC1f {
  text-align: center;
  margin-bottom: 16px;
  font-size: 1.5rem;
}

.OnlineUsersPage_userList__\\+-xEI {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.OnlineUsersPage_userItem__LLUw9 {
  background: #fff;
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333;
}

.OnlineUsersPage_name__0j-SK {
  font-weight: 500;
}

.OnlineUsersPage_username__gcMAq {
  color: #555;
}

.OnlineUsersPage_noUsers__imqtI {
  text-align: center;
  background: none;
  box-shadow: none;
  color: #666;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/modules/Admin/OnlineUsersPage/OnlineUsersPage.module.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* src/components/OnlineUsersPage/OnlineUsersPage.module.css */\r\n.onlineUsersPage {\r\n  max-width: 400px;\r\n  margin: 0 auto;\r\n  padding: 16px;\r\n  font-family: sans-serif;\r\n}\r\n\r\n.heading {\r\n  text-align: center;\r\n  margin-bottom: 16px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.userList {\r\n  list-style: none;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.userItem {\r\n  background: #fff;\r\n  padding: 12px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 16px;\r\n  color: #333;\r\n}\r\n\r\n.name {\r\n  font-weight: 500;\r\n}\r\n\r\n.username {\r\n  color: #555;\r\n}\r\n\r\n.noUsers {\r\n  text-align: center;\r\n  background: none;\r\n  box-shadow: none;\r\n  color: #666;\r\n  font-style: italic;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"onlineUsersPage": `OnlineUsersPage_onlineUsersPage__nJSZm`,
	"heading": `OnlineUsersPage_heading__iCC1f`,
	"userList": `OnlineUsersPage_userList__+-xEI`,
	"userItem": `OnlineUsersPage_userItem__LLUw9`,
	"name": `OnlineUsersPage_name__0j-SK`,
	"username": `OnlineUsersPage_username__gcMAq`,
	"noUsers": `OnlineUsersPage_noUsers__imqtI`
};
export default ___CSS_LOADER_EXPORT___;
